module.exports = __webpack_public_path__ + "img/work1.810b33a9.jpg";